<template>
  <div class="newWarp h100">
    <mobileHeader></mobileHeader>
    <div class="page page-5">
      <div class="page5Warp flexB h100">
        <div class="zwHeader w100"></div>
        <div class="content flex1 w100">
          <div class="title fAb">
            <div>Viewpoint</div>
            <div class="mobileBak">
              <mobileBak :home-index="5"></mobileBak>
            </div>
          </div>
          <div class="list">
            <div class="newRight">
              <div class="homeAtrList">
                <div class="homeAtrItem fOH" v-for="(v,i) in newsList.list" @click="goDetail(v)">
                  <div class="atrTitle">{{ v.title }}</div>
                  <div class="atrDesc">{{ v.time }}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import NewsView from "@/components/News/mobile.vue";
import mobileHeader from "@/components/Common/MobileHeader.vue";
import mobileBak from "@/components/Common/mobileBak.vue";

export default {
  components: {mobileBak, mobileHeader, NewsView},
  methods: {
    goDetail(v) {
      this.$emit('goDetail',v)
    }
  },
  computed: {
    newsList() {
      return this.$store.getters.viewPointList
    }
  }
}
</script>
<style scoped lang="scss">
.page-5 {
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_7.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .page5Warp {
    .mobileBak{
      position: absolute;
      right: 1.3rem;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
    }
    .content {
      flex: 1;
      overflow: hidden;
      color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;

      .title {
        font-size: 1.5rem;
        padding: 1rem;
        position: relative;
        width: 100%;
        text-align: center;
        box-sizing: border-box;
      }

      .list {
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
        padding: 0 1.3rem 1rem;

        .newRight {
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;

          .homeAtrList {
            .homeAtrItem {
              border-bottom: .12rem solid rgba(255, 255, 255, .4);
              padding: 1rem 0;

              .atrTitle {
                font-size: .75rem;
                color: #fff;
                line-height: 1.3rem;
              }

              .atrDesc {
                font-size: .7rem;
                margin-top: .5rem;
                color: #8FCADD;
              }

            }
          }
        }
      }
    }
  }
}

</style>
